// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3TgDk","choiceBoxes":"toolbarselects_choiceBoxes__2-SIh","simpleField":"toolbarselects_simpleField__1hdsC"};